import React, { useEffect, useState } from "react";
import "./DXFLoader.css";

const STEPS = [
  "INITIALISATION DU PARSEUR…",
  "LECTURE DES CALQUES…",
  "EXTRACTION DES ENTITÉS…",
  "CALCUL DES COORDONNÉES…",
  "RENDU DE LA SCÈNE…",
];

export default function DXFLoader() {
  const [stepIdx, setStepIdx] = useState(0);
  const [dots, setDots]       = useState("");

  useEffect(() => {
    const dotTimer = setInterval(() => {
      setDots(d => d.length >= 3 ? "" : d + ".");
    }, 380);

    const stepTimer = setInterval(() => {
      setStepIdx(i => (i + 1) % STEPS.length);
    }, 900);

    return () => {
      clearInterval(dotTimer);
      clearInterval(stepTimer);
    };
  }, []);

  return (
    <div className="dxfl-overlay">

      {/* Coins HUD */}
      <span className="dxfl-corner dxfl-corner--tl" />
      <span className="dxfl-corner dxfl-corner--tr" />
      <span className="dxfl-corner dxfl-corner--bl" />
      <span className="dxfl-corner dxfl-corner--br" />

      {/* Grille de fond */}
      <div className="dxfl-grid" />

      {/* Centre */}
      <div className="dxfl-center">

        {/* Anneaux tournants */}
        <div className="dxfl-rings">
          <div className="dxfl-ring dxfl-ring--1" />
          <div className="dxfl-ring dxfl-ring--2" />
          <div className="dxfl-ring dxfl-ring--3" />
          <div className="dxfl-core" />
        </div>

        {/* Texte */}
        <div className="dxfl-label">PARSING DXF{dots}</div>
        <div className="dxfl-step">{STEPS[stepIdx]}</div>

        {/* Barre de scan */}
        <div className="dxfl-scanbar-wrap">
          <div className="dxfl-scanbar" />
        </div>

      </div>

    </div>
  );
}
